import React, { createContext, useContext } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import "../css/chatmarkdown.css";

const ChatMarkdown = ({ content }: { content: string }) => {
  const InsideLiContext = createContext(false);
  const LiWrapper: React.FC<React.HTMLAttributes<HTMLLIElement>> = ({
    children,
    ...props
  }) => {
    return (
      <li {...props}>
        <InsideLiContext.Provider value={true}>
          {children}
        </InsideLiContext.Provider>
      </li>
    );
  };

  const PWrapper: React.FC<React.HTMLAttributes<HTMLParagraphElement>> = ({
    children,
    ...props
  }) => {
    const insideLi = useContext(InsideLiContext);

    if (insideLi) {
      // Avoid wrapping <p> inside <li>
      return <>{children}</>;
    }

    return (
      <p className="chat-paragraph" {...props}>
        {children}
      </p>
    );
  };
  return (
    <div className="chat-markdown">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          p: PWrapper,

          li: LiWrapper,
          ul: ({ node, ...props }) => <ul className="chat-ul" {...props} />,
          ol: ({ node, ...props }) => <ol className="chat-ol" {...props} />,
          blockquote: ({ node, ...props }) => (
            <blockquote className="chat-quote" {...props} />
          ),
          a: ({ node, ...props }) => (
            <a
              className="chat-link"
              target="_blank"
              rel="noreferrer"
              {...props}
            />
          ),
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
};

export default ChatMarkdown;
